import React from 'react';

interface LocationControlProps {
  onLocateUser: () => void;
}

const MyLocationIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>
    </svg>
)

export const LocationControl: React.FC<LocationControlProps> = ({ onLocateUser }) => {
  return (
    <div className="bg-white bg-opacity-80 backdrop-blur-sm p-2 rounded-lg shadow-lg border border-gray-200">
      <button
        onClick={onLocateUser}
        className="w-full h-full flex items-center justify-center bg-white text-gray-700 rounded-md p-2 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-cyan-500 transition-colors"
        aria-label="Find my location"
      >
        <MyLocationIcon />
      </button>
    </div>
  );
};
